<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
    <UPDATE  ref="copyUpdate"  @submit="copySubmit" :updateData="copyUpdateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import Url from '@/views/newmis36/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import Qs from 'qs'
  let typeList = {};
  let typeUrlMap = {};
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    mounted(){
        this.dataChanage(Url.active.type.queryAll,{},res => {
            if (res.code == 0){
                let arr = res.result;
                for (const i in arr) {
                    typeUrlMap[arr[i].type] = arr[i].url;
                    typeList[arr[i].type] = arr[i].type;
                }
                this.updateData.cols = [
                    { title: 'id', field: 'id',hidden:true},
                    { title: window.$t('txmis.activeTemplate.type'), field: 'type',type:2,optionList:typeList,readonly:(model,col)=>{
                        return model.id?true:false;
                        },required:true},
                    { title: window.$t('txmis.activeTemplate.title'), field: 'title',required:true},
                    { title: window.$t('txmis.activeTemplate.activeTime'), field: 'activeTime',type:9,data:[],required:true},
                    { title: window.$t('txmis.activeTemplate.author'), field: 'author',required:true},
                    { title: window.$t('txmis.activeTemplate.url'), field: 'url',type:12,dataRender:(model,col)=>{
                        this.$set(col,"data",typeUrlMap[model.type]);
                        },required:true},
                    { title: window.$t('txmis.activeTemplate.detail'), field: 'detail',hidden:true},
                ];
            }
        })
    },
    methods: {
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
            row.activeTime=[row.startTime,row.endTime];
            this.$refs.childUpdate.open(row);
        }else if(clickName == "delete"){
            this.dataChanage(Url.active.active.del,{id:row.id},res => {
                this.$refs.childTable.defaultGetData(this.queryData);
                if (res.code == 0){
                    this.$refs.childUpdate.close();
                    this.$message.success("suc");
                }else{
                    this.$message.error(res.message);
                }
            })
        }else if(clickName == "detail"){
            this.$router.push({path:"/newmis36/activeTemplate/activetemplateDetail",query:{id:row.id,label:"TREX"}});
        }else if(clickName == "copy"){
            this.$refs.copyUpdate.open(row);
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t('txmis.bt.search') == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(data);
        }else if(window.$t('txmis.bt.add') == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        model.startTime = model.activeTime[0];
        model.endTime = model.activeTime[1];
        this.dataChanage(model.id?Url.active.active.edit:Url.active.active.save,model,res => {
            this.$refs.childTable.defaultGetData(this.queryData);
            if (res.code == 0){
                this.$refs.childUpdate.close();
                this.$message.success("suc");
            }else{
                this.$message.error(res.message);
            }
        })
      },
      copySubmit(model){
        this.dataChanage(Url.active.active.copy,model,res => {
            this.$refs.childTable.defaultGetData(this.queryData);
            if (res.code == 0){
                this.$refs.copyUpdate.close();
                this.$message.success("suc");
            }else{
                this.$message.error(res.message);
            }
        })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
          if(suc && (typeof suc == 'function')) suc(res);
        }).catch(res => {
            if(fail && (typeof fail == 'function')) fail(res);
        })
      }
    },
    data () {
      return {
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[]
        },
        copyUpdateData:{
            cols:[
                { title: 'id', field: 'id',hidden:true},
                { title: window.$t('txmis.activeTemplate.type'), field: 'type',required:true},
                { title: window.$t('txmis.activeTemplate.url'), field: 'url',required:true},
            ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: window.$t('txmis.activeTemplate.type'), field: 'type'},
              {click: window.$t('txmis.bt.search')},
              {click: window.$t('txmis.bt.add')},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.active.active.query,
          selection: true,
          sequence: true,
          cols: [
              { title: 'id', field: 'id'},
              { title: window.$t('txmis.activeTemplate.type'), field: 'type'},
              { title: window.$t('txmis.activeTemplate.title'), field: 'title'},
              { title: window.$t('txmis.common.startTime'), field: 'startTime',render: (data, full) => {
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
              }},
              { title: window.$t('txmis.common.endTime'), field: 'endTime',render: (data, full) => {
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
              }},
              { title: window.$t('txmis.activeTemplate.author'), field: 'author'},
              { title: window.$t('txmis.activeTemplate.url'), field: 'url'},
              {title:window.$t('txmis.bt.operation'),width:400,btnClick:[
                  {name:window.$t('txmis.bt.edit'),click:"update",type:"primary",icon:"el-icon-edit"},
                  {name:window.$t('txmis.bt.delete'),click:"delete",type:"primary",icon:"el-icon-delete"},
                  {name:window.$t('txmis.activeTemplate.detail'),click:"detail",type:"primary",icon: "el-icon-edit"},
                  {name:window.$t('txmis.activeTemplate.copy'),click:"copy",type:"primary",icon: "el-icon-edit"}
              ]},
          ]
        }
      }
    }
  }
</script>
